import Image from "next/legacy/image";

export { GiraffeTable } from "./svgs/GiraffeTable";
export { GiraffeFlag } from "./svgs/GiraffeFlag";
export { GiraffeProtectTabSwitcher } from "./svgs/GiraffeProtectTabSwitcher";
export { GiraffeFit } from "./svgs/GiraffeFit";
export { FlexibleYugi } from "./svgs/FlexibleYugi";
export { GiraffeTailor } from "./svgs/GiraffeTailor";
export { HRYugi } from "./svgs/HRYugi";
export { GiraffeProtectCritical } from "./svgs/GiraffeProtectCritical";
export { MeetYugi } from "./svgs/MeetYugi";
export { GiraffeLeaderboards } from "./svgs/GiraffeLeaderboards";
export { GiraffePeeper } from "./svgs/GiraffePeeper";
export { SuperGiraffe } from "./svgs/SuperGiraffe";
import MenuYugiSvg from "../../public/static/giraffes/MenuYugi.svg";

export const MenuYugi = () => <Image src={MenuYugiSvg} alt="Yugi, YuLife’s giraffe mascot" />;
